import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Modal } from '@care/react-component-lib';
import useTestFlags from '@/components/hooks/useTestFlags';

const CareOrgModal = ({
  openCareOrgModal,
  setOpenCareOrgModal,
}: {
  openCareOrgModal: boolean;
  setOpenCareOrgModal: (open: boolean) => void;
}) => {
  const { greaterCare } = useTestFlags();
  const isGreaterCare = greaterCare?.value === 1;

  return (
    <Modal
      open={openCareOrgModal}
      onClose={() => setOpenCareOrgModal(false)}
      data-testid="care-org-modal">
      <Box sx={{ textAlign: 'left' }}>
        <Typography variant="h2">Care.org</Typography>
        <Typography mt={2}>
          Cooperative for Assistance and Relief Everywhere, Inc. (CARE), is a leading humanitarian
          relief and development organization fighting global poverty, which is unrelated to
          Care.com but is one of Care.com&apos;s preferred charities. Visit Care.org for more
          information about this organization.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 6 }}>
          <Button
            color={isGreaterCare ? 'primary' : 'secondary'}
            variant="contained"
            size="medium"
            onClick={() => {
              window.location.assign('https://www.care.org/');
            }}>
            Visit Care.org
          </Button>
          <Box mt={2}>
            <Button
              sx={{
                ...(isGreaterCare && {
                  textDecoration: 'underline',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }),
              }}
              onClick={() => setOpenCareOrgModal(false)}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CareOrgModal;
